import { getLocaleDomains } from "./get-locale-domains";

/**
 * Environment-prefixed hostnames for all registry locales (e.g.
 * `local.homeinstead.com` when `subdomain` is `"local"`).
 */
function getLocaleEnvironmentHostnames(subdomain: string): readonly string[] {
  return getLocaleDomains().map((domain) => `${subdomain}.${domain}`);
}

function getLocaleEnvironmentOrigins(subdomain: string): readonly string[] {
  return getLocaleEnvironmentHostnames(subdomain).map(
    (hostname) => `https://${hostname}`,
  );
}

function isLocaleEnvironmentHostname(
  hostname: string,
  subdomain: string,
): boolean {
  for (const domain of getLocaleDomains()) {
    if (hostname === `${subdomain}.${domain}`) {
      return true;
    }
  }

  return false;
}

export {
  getLocaleEnvironmentHostnames,
  getLocaleEnvironmentOrigins,
  isLocaleEnvironmentHostname,
};
